const secondFormQuestions = [
  "1. Prijavitelj projekta/voditelj projektnog tima sa strane FESB-a",
  "2. Naziv, akronim i rok za prijavu",
  "3. Sažetak projekta (do 500 znakova ne uključujući razmake)",
  "4. Poveznica za natječaj",
  "5. Izvor financiranja projekta**",
  "6. Vrsta projekta**",
  "7. Očekivani početak projekta",
  "8. Očekivano trajanje projekta (u mjesecima)**",
  "9. Koordinator projekta",
  "10. Ostali partneri na projektu*",
  "11. U projektu kao partner sudjeluju gospodarski subjekti **",
  "12. Ukupna vrijednost projekta *",
  "13. Proračun projekta (može se unositi vrijedost ili postotak ukupne vrijednosti projekta*)",
  "14. Proračun za ostale partnere",
  "15. Predujam (iznos ili postotak)**",
  "16. Iznos potrebnog vlastitog sufinanciranja projekta **",
  "17. Jesu li u projektu planirana nova radna mjesta **",
  "18. Navedite sve članove projektnog tima s % angažmana",
  "19. Planirate li koristiti konzultantsku pomoć prilikom prijave projekta? **",
  "20. Navedite dokumentaciju koju je potrebno osigurati za prijavu projekta od strane FESB-a **",
];

const firstFormQuestions = [
  "1. Prijavitelj projekta/voditelj projektnog tima sa strane FESB-a",
  "2. Naziv, akronim i rok za prijavu",
  "3. Sažetak projekta (do 500 znakova ne uključujući razmake)**",
  "4. Poveznica za natječaj",
  "5. Koordinator projekta",
  "6. Ostali partneri na projektu**",
  "7. Proračun projekta",
  "8. Jesu li u okviru projekta planirana nova radna mjesta",
  "9. Navedite sve članove projektnog tima s % angažmana",
];

const radioButtonData1 =
  "Ukoliko je jedan od partnera u projektu tvrtka i/ili postoji" +
  " prijenos znanja/tehnologije prema gospodarstvu koje je nužno ostvariti" +
  " tijekom provedbe projekta odaberite DA";

export { firstFormQuestions, radioButtonData1, secondFormQuestions };
